import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { Carousel } from 'javascripts/components/carousel';

import { useGraphQLClientData } from 'javascripts/hooks/use-graphql-client-data';

export function CarouselWithGraphQL(props) {
  const graphQLResponse = useGraphQLClientData(props.query, props.queryParams);

  useEffect(() => {
    if (!graphQLResponse.loading) {
      props.onDataLoad(graphQLResponse);
    }
  }, [graphQLResponse.loading]);

  return (
    <Carousel
      arrowTrackingCategory={props.arrowTrackingCategory}
      hasLoaded={!graphQLResponse.loading}
      title={props.title}
      items={props.renderResponseFunction(graphQLResponse, props.trackingCategory)}
      centerArrows={props.centerArrows}
      emptyMessage={props.emptyMessage}
      slideSize={props.slideSize}
      hideArrows={props.hideArrows}
      hideEmptyCarousel={props.hideEmptyCarousel}
      linkHref={props.linkHref}
      titleElement={props.titleElement}
      linkText={props.linkText}
      linkTracker={props.linkTracker}
      minSize={props.minSize}
      placeholderItem={props.placeholderItem}
      useSmallArrows={props.useSmallArrows}
    />
  );
}

CarouselWithGraphQL.propTypes = {
  query: PropTypes.string.isRequired,
  queryParams: PropTypes.object,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  renderResponseFunction: PropTypes.func.isRequired,
  trackingCategory: PropTypes.string.isRequired,
  slideSize: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7]).isRequired,
  arrowTrackingCategory: PropTypes.string,
  centerArrows: PropTypes.bool,
  emptyMessage: PropTypes.string,
  hideArrows: PropTypes.bool,
  hideEmptyCarousel: PropTypes.bool,
  linkHref: PropTypes.string,
  minSize: PropTypes.number,
  titleElement: PropTypes.oneOf(['div', 'h2', 'h3']),
  linkText: PropTypes.string,
  linkTracker: PropTypes.func,
  onDataLoad: PropTypes.func,
  placeholderItem: PropTypes.element,
  useSmallArrows: PropTypes.bool,
};

CarouselWithGraphQL.defaultProps = {
  queryParams: {},
  centerArrows: false,
  hideEmptyCarousel: false,
  minSize: 0,
  placeholderItem: null,
  useSmallArrows: false,
  onDataLoad: _.noop,
};
